// ============================================
// HEADER UTILITY FUNCTIONS
// Sidebar open/close logic and background management
// ============================================

/**
 * Close all sidebars (with option to exclude some)
 */
export const closeAllSidebars = (
  except: string[] = [],
  openSidebarsRef: React.MutableRefObject<Set<string>>
) => {
  const exceptSet = new Set(except)
  const sidebars = document.querySelectorAll('.sidebar')
  const sidebarOverlay = document.querySelector('.sidebar-overlay')
  const menuToggle = document.querySelector('.menu-toggle')

  sidebars.forEach((sidebar: Element) => {
    const sidebarName = sidebar.getAttribute('data-sidebar')
    if (sidebarName && !exceptSet.has(sidebarName)) {
      sidebar.classList.remove('active')
      sidebar.classList.remove('from-menu')
      openSidebarsRef.current.delete(sidebarName)
    }
  })

  // Si no quedan sidebars abiertos, cerrar overlay y restaurar scroll
  if (openSidebarsRef.current.size === 0) {
    sidebarOverlay?.classList.remove('active')
    document.body.style.overflow = ''
    restoreVideoBackground()
    // Restaurar hamburguesa a estado normal
    menuToggle?.classList.remove('opened')
  }

  // Remover clase "active" de todos los botones con flecha
  document.querySelectorAll('.nav-link.active').forEach(btn => {
    const btnSidebarName = btn.getAttribute('data-sidebar-trigger')
    if (btnSidebarName && !exceptSet.has(btnSidebarName)) {
      btn.classList.remove('active')
    }
  })
}

/**
 * Open specific sidebar (EXACT COMO ASTRO)
 */
export const openSidebar = (
  sidebarName: string,
  triggerButton: Element | null = null,
  openSidebarsRef: React.MutableRefObject<Set<string>>,
  closeAllSidebarsFunc: (except?: string[]) => void
) => {
  const fromMenu = triggerButton?.getAttribute('data-from-menu') === 'true'
  const sidebar = document.querySelector(`[data-sidebar="${sidebarName}"]`)
  const sidebarOverlay = document.querySelector('.sidebar-overlay')
  const menuToggle = document.querySelector('.menu-toggle')

  // Si viene desde menú principal, mantenerlo abierto
  if (fromMenu) {
    closeAllSidebarsFunc(['menu-principal'])
  } else {
    closeAllSidebarsFunc()
  }

  if (sidebar) {
    if (fromMenu) {
      sidebar.classList.add('from-menu')
    }

    sidebar.classList.add('active')
    sidebarOverlay?.classList.add('active')
    document.body.style.overflow = 'hidden'
    openSidebarsRef.current.add(sidebarName)

    // Agregar clase "active" al botón trigger (para rotar flecha)
    if (triggerButton) {
      triggerButton.classList.add('active')
    }

    // Cambiar hamburguesa a X cuando hay sidebars abiertos
    menuToggle?.classList.add('opened')

    changeToStaticBackground()
  }
}

/**
 * Change to static image when sidebar opens
 */
export const changeToStaticBackground = () => {
  const videoContainer = document.querySelector('.hero-video-container')
  const staticBg = document.querySelector('.hero-static-bg')

  if (videoContainer) {
    videoContainer.classList.add('hidden-for-sidebar')
  }
  if (staticBg) {
    staticBg.classList.add('active')
  }
}

/**
 * Restore video when sidebar closes
 */
export const restoreVideoBackground = () => {
  const videoContainer = document.querySelector('.hero-video-container')
  const staticBg = document.querySelector('.hero-static-bg')

  if (videoContainer) {
    videoContainer.classList.remove('hidden-for-sidebar')
  }
  if (staticBg) {
    staticBg.classList.remove('active')
  }
}
